import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { MensajeSiNo } from "../../mensajes2";
import moment from "moment";
export const ImpFacturaEmitidas = (props) => {
  const op = require("../../../../src/modulos/datos");
  const fechaActual = new Date().toISOString().split("T")[0];
  const anioActual = new Date().getFullYear();

  const [filtro, setFiltro] = useState("fecha");
  const [tipoReporte, setTipoReporte] = useState("emitidas");
  const [fechas, setFechas] = useState({
    desde: `${anioActual}-01-01`,
    hasta: fechaActual,
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const TITULO = {
    emitidas: "Impresion General de Facturas Emitidas",
    porCobrar: "Impresion General de Facturas por Cobrar",
    cobradas: "Impresion General de Facturas Cobradas",
    anuladas: "Impresion General de Facturas Anuladas",
  };
  const reporteTipoIngreso = () => {
    let condicion = "true";
    let titulo = "";
    if (filtro === "fecha") {
      condicion = `FechaEmision between '${fechas.desde}'::date and '${fechas.hasta}'::date`;
      titulo = `DESDE EL ${moment(fechas.desde).format("DD-MM-YYYY")} HASTA EL ${moment(fechas.hasta).format("DD-MM-YYYY")}`;
    }
    window.open(
      op.reportes +
        "/factura?reporte=FacTipoIngreso" +
        `&CONDICION=${condicion}` +
        `&TIT_RGO1=${titulo}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const reporteEmitidos = () => {
    let condicion = "true";
    let titulo = "";
    if (filtro === "fecha") {
      condicion = `FechaEmision between '${fechas.desde}'::date and '${fechas.hasta}'::date`;
      titulo = `DESDE EL ${moment(fechas.desde).format("DD-MM-YYYY")} HASTA EL ${moment(fechas.hasta).format("DD-MM-YYYY")}`;
    }
    window.open(
      op.reportes +
        "/factura?reporte=FacEmitidas" +
        `&CONDICION=${condicion}` +
        `&TIT_RGO1=${titulo}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const reportePorCobrar = () => {
    let condicion = "Status=0 ";
    let titulo = "";
    let titulo2 = "";
    if (filtro === "fecha") {
      condicion += ` and FechaEmision between '${fechas.desde}'::date and '${fechas.hasta}'::date`;
      titulo = `DESDE EL ${moment(fechas.desde).format("DD-MM-YYYY")}`;
      titulo2 = `HASTA EL ${moment(fechas.hasta).format("DD-MM-YYYY")}`;
    }
    window.open(
      op.reportes +
        "/factura?reporte=FacTipoIngreso" +
        `&CONDICION=${condicion}` +
        `&TIT_RGO1=${titulo}&TIT_RGO2=${titulo2}&TIT_RGO3=Facturas por Cobrar`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const reporteCobrados = () => {
    let condicion = "Status=1 ";
    let titulo = "";
    let titulo2 = "";
    if (filtro === "fecha") {
      condicion += ` and caja.numfactura = fac.numfactura AND caja.Fechapago between '${fechas.desde}'::date and '${fechas.hasta}'::date`;
      titulo = `DESDE EL ${moment(fechas.desde).format("DD-MM-YYYY")}`;
      titulo2 = `HASTA EL ${moment(fechas.hasta).format("DD-MM-YYYY")}`;
    }
    window.open(
      op.reportes +
        "/factura?reporte=FactTipoIngresoPaga" +
        `&CONDICION=${condicion}` +
        `&TIT_RGO3=Facturas Cobradas&TIT_RGO1=${titulo}&TIT_RGO2=${titulo2}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const reporteAnulados = () => {
    let condicion = "FAC.Status=2 ";
    if (filtro === "fecha") {
      condicion += ` and FechaOperacion between '${fechas.desde}'::date and '${fechas.hasta}'::date`;
    }
    window.open(
      op.reportes +
        "/factura?reporte=FacAnuladas" +
        `&CONDICION=${condicion}` +
        "&TIT_RGO1=Facturas Anuladas",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const imprimirReporte = () => {
    switch (tipoReporte) {
      case "emitidas":
        setMensajesino({
          mostrar: true,
          titulo: "Facturas Emitidas.",
          texto: `Desea Imprimir el Listado \n"
                  Agrupado por Tipo de Impuesto?`,
          icono: "confirmacion",
        });
        break;
      case "porCobrar":
        reportePorCobrar();
        break;
      case "cobradas":
        reporteCobrados();
        break;
      case "anuladas":
        reporteAnulados();
        break;
      default:
        break;
    }
  };
  const salir = () => {
    blanquear();
    props.onHideCancela();
  };
  const blanquear = () => {
    setFiltro("fecha");
    setTipoReporte("emitidas");
    setFechas({
      desde: fechaActual,
      hasta: fechaActual,
    });
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgba(0, 0, 0, 0.521)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setTipoReporte(props.tipo);
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-5 fw-bold text-light m-0">
          {TITULO[tipoReporte] || ""}
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between col-md-12">
          <fieldset className="col-md-12 row mb-1 border-azul row rounded">
            <legend
              className="float-none w-auto fw-bold text-uppercase"
              style={{
                fontSize: "0.9rem",
              }}
            >
              Buscar por:
            </legend>
            <div className="col-md-12 row d-flex justify-content-center align-items-center">
              {/* <div className="form-check col-md-1 m-2 d-flex align-items-center">
                <label className="form-check-label">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="tipoReporte"
                    value="todo"
                    checked={filtro === "todo"}
                    onChange={(e) => setFiltro(e.target.value)}
                  />
                  Todo
                </label>
              </div> */}
              {/* <div className="form-check col-md-2 m-2 d-flex align-items-center">
                <label className="form-check-label">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="tipoReporte"
                    value="fecha"
                    checked={filtro === "fecha"}
                    onChange={(e) => setFiltro(e.target.value)}
                  />
                  Por Fecha
                </label>
              </div> */}

              <div
                className="col-md-4 row py-2 m-1"
                style={{
                  visibility: filtro === "fecha" ? "visible" : "hidden",
                }}
              >
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Desde:
                  </span>
                  <input
                    type="date"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    max={fechaActual}
                    value={fechas.desde}
                    onChange={(e) => {
                      const { value } = e.target;
                      setFechas((prev) => ({
                        ...prev,
                        desde: value,
                      }));
                    }}
                  />
                </div>
              </div>
              <div
                className="col-md-4 row py-2 m-1"
                style={{
                  visibility: filtro === "fecha" ? "visible" : "hidden",
                }}
              >
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Hasta:
                  </span>
                  <input
                    type="date"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    max={fechaActual}
                    value={fechas.hasta}
                    onChange={(e) => {
                      const { value } = e.target;
                      setFechas((prev) => ({
                        ...prev,
                        hasta: value,
                      }));
                    }}
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => imprimirReporte()}
          className="btn-sm rounded-pill btn btn-info col-md-2"
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <MensajeSiNo
        mensaje={mensajesino}
        onHideSi={() => {
          reporteTipoIngreso();
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
        onHideNo={() => {
          reporteEmitidos();
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};
